import { useMemo } from "react";
import { useCounterpartiesQuery } from "@api/counterparty.api";
import { DirectorySort } from "@common/constants/counterparty";
import { RegisteredCounterpartyIncludeScope } from "@common/helpers/counterparties";

export function useCounterpartyNameMap(): Map<string, string> {
    const counterpartiesQuery = useCounterpartiesQuery({
        sort: DirectorySort.NAME_ASC,
        includeRegistered: RegisteredCounterpartyIncludeScope.USED,
    });

    return useMemo(() => {
        const namesById = new Map<string, string>();
        for (const row of counterpartiesQuery.data?.data ?? []) {
            if (row.counterparty) {
                namesById.set(row.counterparty.id, row.counterparty.name);
            }
        }
        return namesById;
    }, [counterpartiesQuery.data]);
}
